module.exports = __webpack_public_path__ + "static/media/2-option8-4row.20486702.png";